import { useState } from "react";
import {
  ArrowRightOutlined,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { Alert, Button, Form, Input, Typography } from "antd";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export function LoginPage() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  if (admin) return <Navigate to="/dashboard" replace />;

  async function submit(values: { email: string; password: string }) {
    setError(null);
    try {
      await login(values.email, values.password);
      const target =
        (location.state as { from?: string } | null)?.from ?? "/dashboard";
      navigate(target, { replace: true });
    } catch (cause) {
      setError(
        cause instanceof Error ? cause.message : "登录失败，请稍后再试。",
      );
    }
  }

  return (
    <main className="login-page">
      <section className="login-signal" aria-hidden="true">
        <div className="brand-lockup">
          <div className="brand-mark">
            <span />
          </div>
          <span>DELTABEACON</span>
        </div>
        <div className="signal-readout">
          <span>
            <i className="pulse-dot" /> 在线
          </span>
          <strong>30 · 50 · 80 · 100</strong>
        </div>
      </section>
      <section className="login-panel">
        <div className="login-card">
          <Typography.Title level={1}>登录控制台</Typography.Title>
          {error ? (
            <Alert
              type="error"
              showIcon
              title={error}
              className="login-error"
            />
          ) : null}
          <Form
            layout="vertical"
            size="large"
            onFinish={submit}
            requiredMark={false}
          >
            <Form.Item
              label="管理员邮箱"
              name="email"
              rules={[
                { required: true, type: "email", message: "请输入有效邮箱" },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                autoComplete="email"
                placeholder="admin@example.com"
              />
            </Form.Item>
            <Form.Item
              label="密码"
              name="password"
              rules={[{ required: true, message: "请输入密码" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                autoComplete="current-password"
                placeholder="输入登录密码"
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              icon={<ArrowRightOutlined />}
              iconPlacement="end"
            >
              登录
            </Button>
          </Form>
        </div>
      </section>
    </main>
  );
}
